import { NotFoundModule } from './not-found/not-found.module';
import { AgmCoreModule } from '@agm/core';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { SDKBrowserModule } from '@careapp/angular-sdk';
import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { FlexLayoutModule } from '@angular/flex-layout';

import { environment, production } from '../environments/environment';
import { AboutModule } from './about/about.module';
import { AdminModule } from './admin/admin.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomSerializer } from './custom-serializer';
import { HomeModule } from './home/home.module';
import { LoginModule } from './login/login.module';
import { OrganisationModule } from './organisation/organisation.module';
import { ProfileModule } from './profile/profile.module';
import { ResetModule } from './reset/reset.module';
import { GOOGLE_MAPS_API_KEY } from './shared/services/index';
import { SharedModule } from './shared/shared.module';
import { EFFECTS } from './store/effects/index';
import { META_REDUCERS } from './store/reducers/index';
import { REDUCERS } from './store/reducers/index';
import { RollbarService, RollbarModule } from 'angular-rollbar';
import { NFErrorHandler, ERROR_LOGGING_SERVICE } from './error-handler/error-handler';
import { DevmodInterfaceModule, DevmodNoopModule } from '@devmod/interface';
import * as SDK from '@careapp/angular-sdk';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';

export function sdkFactory() {
  return SDK;
}

let devmod = DevmodNoopModule;
if (!production) {
  devmod = DevmodInterfaceModule;
}

export function windowFactory() {
  return window;
}
export function providers() {
  return [
    {
      provide: RouterStateSerializer,
      useClass: CustomSerializer
    },
    {
      provide: GOOGLE_MAPS_API_KEY,
      useValue: environment.GOOGLE_MAPS_API_KEY
    },
    {
      provide: ERROR_LOGGING_SERVICE,
      useClass: RollbarService
    },
    {
      provide: 'Window',
      useFactory: windowFactory
    }
  ];
}

export function productionProviders() {
  return [
    ...providers(),
    {
      provide: ErrorHandler,
      useClass: NFErrorHandler
    }
  ];
}

@NgModule({
  imports: [
    AboutModule,
    AdminModule,
    AppRoutingModule,
    BrowserModule,
    devmod,
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_MAPS_API_KEY
    }),
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MarkedOptions,
        useValue: {
          smartLists: true
        }
      }
    }),
    FlexLayoutModule,
    HomeModule,
    HttpClientModule,
    HttpModule,
    LoginModule,
    OrganisationModule,
    ProfileModule,
    ResetModule,
    SharedModule.forRoot(),
    SDKBrowserModule.forRoot(),
    StoreModule.forRoot(REDUCERS, { metaReducers: META_REDUCERS }),
    EffectsModule.forRoot(EFFECTS),
    RollbarModule.forRoot({
      accessToken: environment.ROLLBAR_ACCESS_TOKEN,
      payload: {
        environment: environment.ROLLBAR_ENV_NAME
      },
      captureUnhandledRejections: true,
      captureUncaught: true
    }),
    StoreDevtoolsModule.instrument(),
    StoreRouterConnectingModule,
    // Must be last - route catch-all to redirect to /
    NotFoundModule
  ],
  declarations: [AppComponent],
  providers: environment.production ? productionProviders() : providers(),
  bootstrap: [AppComponent]
})
export class AppModule {}
